import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { CardModule } from '@modules/card/card.module';
import { SharedModule } from '@modules/shared/shared.module';

import { ArticleGalleryComponent } from './article-gallery/article-gallery.component';
import { ArticleStatusBarComponent } from './article-status-bar/article-status-bar.component';
import { ArticleComponent } from './article.component';
import { ExpandableCopyComponent } from './expandable-copy/expandable-copy.component';
import { MasonryGalleryComponent } from './masonry-gallery/masonry-gallery.component';

@NgModule({
  exports: [
    ArticleComponent,
    ExpandableCopyComponent,
    ArticleStatusBarComponent,
    ArticleGalleryComponent,
    MasonryGalleryComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    CardModule,
    RouterModule,
    ArticleComponent,
    ExpandableCopyComponent,
    ArticleStatusBarComponent,
    ArticleGalleryComponent,
    MasonryGalleryComponent,
  ],
})
export class ArticleModule {}
